export const ERROR_CODE = 0

//export const COLOR = '#38A28A'
//export const BASEURL = 'https://api.daogangmingxintang.com/'//线上
export const BASEURL = 'https://kind.liqinglin.cn/' //测试
    //export const BASEURL = 'https://test.daogangmingxintang.com/'//本地
export const COLOR = '#30A79B'


// WEBPACK FOOTER //
// ./src/utils/common/config.js